import { TaxRateTypeEnum } from '../../../shared/enums/tax-rate-type.enum';
import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { TransactionRecordCategoryEnum } from '../enums/transaction-record-category.enum';
import { TransactionStatusEnum } from '../enums/transaction-status.enum';
import { TransactionTypeEnum } from '../enums/transaction-type.enum';

import { TransactionLinksDto } from './transaction-links.dto';

/**
 * Transaction DTO for lists
 */
@CaslSubject(AppSubjectEnum.TRANSACTION)
export class TransactionListDto extends BaseDto {
  code!: string;
  recordCategory!: TransactionRecordCategoryEnum;
  type!: TransactionTypeEnum;
  status!: TransactionStatusEnum;
  externalReference?: string | null;
  description?: string | null;
  paymentId?: number | null;
  tags?: TagListDto[] | null;
  links?: TransactionLinksDto | null;
  taxRateType?: TaxRateTypeEnum | null;
  taxRate?: number | null;
  isTaxIncluded?: boolean | null;
  amount?: number | null;
  totalNet?: number | null;
  totalTax?: number | null;
  totalGross?: number | null;
  computedTotalAllocated!: number;
  computedTotalUnallocated!: number;
}
